export default __webpack_public_path__ + "assets/images/default-userpic-4c1b90dffce6bab2b6ef5927874eb390.svg";